import { Button, Popconfirm, Popover } from 'antd'
import {
  BASE_URL as _BASE_URL,
  SRC_URL,
  deleteSeal,
  getOtherWorkSeal,
  getSealList as _getSealList,
  getSealListByAuthor,
  updateMatchSeal
} from '@/server'
import { useAppSelector } from '@/hooks'
import './index.less'
import { Content as _Content } from 'antd/es/layout/layout'
import { useEffect, useState } from 'react'
import { CloseOutlined } from '@ant-design/icons'

const SealAnaysisPage = () => {
  //用于计算选中印章的编号
  const INDEX_CONSTANT = 10000

  //当前画作的Id
  const workId = useAppSelector((state) => state.analysisImageInfo.workId)
  //强制更新组件
  const [forceUpdate, setForceUpdate] = useState<Record<string, never>>({})

  //给个作者可能有多个印章，在选中某个印章时，确定该印章属于哪个作者
  const [selectedAuthor, setSelectedAuthor] = useState<string>('')
  //确定选中的印章，不区分作者，每个显示的印章都有唯一的编号
  const [selectedSeal, setSelectedSeal] = useState<number>(-1)
  //记录要打开“修改”弹窗的印章编号
  const [selectedModifiedSeal, setSelectedModifiedSeal] = useState<number>(-1)
  //记录要打开“对比”弹窗的印章编号
  const [selectedComparedSeal, setSelectedComparedSeal] = useState<number>(-1)
  //由于一个页面只能打开一个“修改”弹窗，只需记录一个弹窗中的选中印章的编号
  const [selectTopK, setSelectTopK] = useState<number>(0)

  //某一画作下，按照作者分类的所有印象信息
  const [sealsByAuthor, setSealsByAuthor] = useState<any>(null)
  //某一画作下，某个印章出现在其他画作中的信息
  const [relatedSeals, setRelatedSeals] = useState<any>(null)
  //某个印章匹配度最高的五个印章图片
  const [modifiedSeals, setModifiedSeals] = useState<string[]>([])

  //“比较”弹窗中的内容
  const relatedSealsContent = (
    <div className='related-seals'>
      <Button
        type='link'
        style={{ margin: '0 auto', color: 'black' }}
        onClick={() => {
          setSelectedComparedSeal(-1)
        }}
      >
        关闭
      </Button>
      {(relatedSeals ?? []).map((seal: any, index: number) => {
        return (
          <div key={index} className='single-seal'>
            <div className='seal-pic'>
              <img src={SRC_URL + seal.worksealPath} className='imgs' />
            </div>
            <div className='seal-info'>
              <div>
                {seal.dynasty}&nbsp;{seal.authorname}
              </div>
              <div>{seal.workname}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
  //鼠标悬停在原始印章上，显示的“操作”弹窗内容
  const sealManipulationContent = (author: string, id: number, sealId: string) => (
    <div className='seal-manipulation'>
      <div className='left'>
        <Button
          className='button'
          onClick={() => {
            if (id === selectedModifiedSeal) {
              resetModifiedSealContent()
            } else {
              setSelectedModifiedSeal(id)
              // handleModification(selectedAuthor, selectedSeal % INDEX_CONSTANT)
              //为了避免出现延迟失效现象，不用状态变量，而用固定参数
              handleModification(author, id % INDEX_CONSTANT)
            }
          }}
          size='large'
        >
          修改
        </Button>
      </div>
      <div className='right'>
        <Button
          className='button'
          onClick={() => {
            if (id === selectedComparedSeal) setSelectedComparedSeal(-1)
            else {
              setSelectedComparedSeal(id)
              handleCompare(sealId)
            }
          }}
          size='large'
        >
          对比
        </Button>
      </div>
    </div>
  )
  //“修改”弹窗的内容
  const sealModifiedContent = (
    <div className={'seal-compare'}>
      <Button
        type='link'
        style={{ margin: 'auto 0', padding: '0', color: 'black', writingMode: 'vertical-lr' }}
        onClick={() => {
          resetModifiedSealContent()
        }}
      >
        关闭
      </Button>
      {(modifiedSeals ?? []).map((seal: any, index: number) => {
        return (
          <Popconfirm
            title='修改'
            description='确认要将该图片修改为最匹配的图片？'
            onConfirm={() => {
              handleModifyConfirm()
            }}
            onCancel={() => {}}
            color='#F3F3F3'
          >
            <div
              className={
                'seal-compare-pic ' + (selectTopK === index ? 'seal-compare-pic-selected' : '')
              }
              onClick={() => {
                setSelectTopK(index)
              }}
            >
              <img src={SRC_URL + seal} className='imgs' />
            </div>
          </Popconfirm>
        )
      })}
    </div>
  )

  //获取并设置选择的印章在其他作品中出现的信息
  const handleSelectedSeal = (sealId: string) => {
    getOtherWorkSeal(sealId).then((res) => {
      setRelatedSeals(res.data.worksealpainting)
    })
  }
  //处理点击“修改”逻辑
  const handleModification = (author: string, index: number) => {
    const tempModifiedSeals: string[] = []
    for (let i = 1; i <= 5; i++) {
      tempModifiedSeals.push(sealsByAuthor[author][index][`top${i}Path`])
    }
    setModifiedSeals(tempModifiedSeals)
  }
  //处理点击“比较”逻辑
  const handleCompare = (sealId: string) => {
    //因为请求可能比较慢，为了避免上一次的结果显示在当前的“比较”弹窗中，在显示弹窗前，先将上一次的结果清空
    setRelatedSeals([])
    //设置“比较”弹窗中的内容
    handleSelectedSeal(sealId)
  }
  const handleModifyConfirm = async () => {
    const worksealId = sealsByAuthor[selectedAuthor][selectedSeal % INDEX_CONSTANT].worksealId
    await updateMatchSeal('/seal/workseal/update/' + worksealId, (selectTopK + 1).toString())
    setForceUpdate({})
  }

  const resetModifiedSealContent = () => {
    setSelectedModifiedSeal(-1)
    setSelectTopK(0)
  }

  const handleDeleteSeal = (sealId: string) => {
    deleteSeal('/seal/workseal/delete', [sealId])
    setForceUpdate({})
  }

  useEffect(() => {
    getSealListByAuthor('/seal/workseal/getWorkSealGroup/' + workId).then((res: any) => {
      setSealsByAuthor(res.data.workseal)
    })
    resetModifiedSealContent()
  }, [forceUpdate])

  return (
    <>
      <div style={{ width: '100%', height: '100%' }}>
        <div className='seal-container'>
          <div className='seal-list'>
            {Object.keys(sealsByAuthor ?? {}).map((name: string, index: number) => {
              return (
                <div key={index}>
                  <div className='seal-author'>作者：{name}</div>
                  {sealsByAuthor[name].map((seal: any, sealIndex: number) => {
                    return (
                      <>
                        {sealIndex === 0 ? (
                          <div className='seal-item-title'>
                            <div className='seal-item-title-text'>作品印章</div>
                            <div className='seal-item-title-text'>匹配印章</div>
                            <div className='seal-item-title-text'>印章内容</div>
                          </div>
                        ) : (
                          <></>
                        )}
                        <Popover
                          placement='rightBottom'
                          content={relatedSealsContent}
                          title=''
                          color='#F3F3F3'
                          open={index * INDEX_CONSTANT + sealIndex === selectedComparedSeal}
                        >
                          <div
                            className={
                              'seal-items' +
                              (selectedSeal === index * INDEX_CONSTANT + sealIndex
                                ? ' seal-items-selected'
                                : '')
                            }
                            onClick={() => {
                              setSelectedSeal(index * INDEX_CONSTANT + sealIndex)
                              // handleSeletedSeal(seal.worksealId)
                              setSelectedAuthor(name)
                            }}
                          >
                            <Popover
                              placement='top'
                              content={sealManipulationContent(
                                name,
                                index * INDEX_CONSTANT + sealIndex,
                                seal.worksealId
                              )}
                              title=''
                              trigger='hover'
                              color='#F5F3EC'
                            >
                              <div className='seal-item'>
                                <img src={SRC_URL + seal.worksealPath} className='imgs' />
                              </div>
                            </Popover>
                            <Popover
                              placement='bottom'
                              content={sealModifiedContent}
                              title=''
                              open={index * INDEX_CONSTANT + sealIndex === selectedModifiedSeal}
                              color='#F3F3F3'
                            >
                              <div className='seal-item'>
                                <img src={SRC_URL + seal.top1Path} className='imgs' />
                              </div>
                            </Popover>
                            <div className='seal-item'>
                              <div className='seal-item-text'>{seal.top1Content}</div>
                              <div className='seal-item-delete'>
                                <CloseOutlined
                                  style={{ fontSize: '16px' }}
                                  onClick={() => {
                                    handleDeleteSeal(seal.worksealId)
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </Popover>
                      </>
                    )
                  })}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

export default SealAnaysisPage
